import { useState, useEffect, useRef } from 'react';
import adminimg from "../../utils/images/admin_img.png";
import leftlogo from "../../utils/images/left_logo.png";
import { useNavigate } from 'react-router-dom';
import veiwFile from "../../utils/images/view_icon.svg";
import closeicon from "../../utils/images/close-icons.svg";
import Modal from "react-bootstrap/Modal";
import arrow from "../../utils/images/arrow_icons.svg";



function Sidebar({ isOpen, setIsOpen }) {
    // const [isOpen, setIsOpen] = useState(true);
    const toggleSidebar = () => setIsOpen(!isOpen);
    const [activeItem, setActiveItem] = useState("Home");
    const [showChat, setShowChat] = useState(false);

    const API_KEY =
        "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";
    const systemContent = `
            Your name is Ivy.
            Your user name is [User's First Name]

            Response Style:
            - Keep responses under 3 sentences
            - Use plain text only (no special characters)
            - Maintain a professional yet friendly tone
            - Be concise but empathetic

            Ivy's Identity:
            "I'm Ivy, your virtual legal assistant here to help with UK legal matters related to Ivy Legal Services. I provide general information about legal processes, but always recommend consulting a solicitor for personal advice."

            Core Services:
            1. Family Law: Divorce, child custody, prenups
            2. Employment: Contracts, disputes, redundancy
            3. Property: Tenancy agreements, landlord disputes
            4. Wills & Probate: Will drafting, inheritance
            5. Business Law: Incorporation, contracts

            Response Rules:
            - Only answer UK legal questions
            - Never give specific legal advice
            - Redirect non-legal queries politely
            - Always mention when professional help is needed

            Example Responses:
            User: "How much does divorce cost?"
            Ivy: "In England/Wales, court fees start at £593. Additional solicitor fees vary. We offer fixed-fee divorce paperwork assistance."

            User: "What's the weather today?"
            Ivy: "I specialize in UK legal matters. Would you like information about family or employment law instead?"

            User: "Can my landlord evict me suddenly?"
            Ivy: "UK landlords must give 2 months' notice under Section 21 rules. If you've received notice, we can review it for validity."

            Emergency Resources:
            - For urgent legal help: Contact Law Society 020 7320 5650
            - Domestic violence: Call Refuge 0808 2000 247
            - Police emergency: 999

            Contact Information:
            Website: www.ivylegal.co.uk
            Phone: 0800 123 4567
            Email: help@ivylegal.co.uk

            Default Response:
            "Sorry, I can only help with UK legal questions. Please visit our website or call us for specific advice."
`;

    const [isChat, setIsChat] = useState();
    const [typing, setTyping] = useState(false);
    const [msg, setMsg] = useState("");
    const chatContainerRef = useRef(null);
    const [isFullscreen, setIsFullScreen] = useState(false);

    const [conversation, setConversation] = useState([
        {
            message:
                "Welcome to Ivy, I am Ivy your virtual assistant How can I help you today?",
            sender: "Ivy",
            direction: "incoming",
        },
    ]);


    const handleCloseChat = () => {
        setShowChat(false);
    };

    const handleOnChange = (e) => {
        setMsg(e.target.value);
    };

    const handleSend = async () => {
    if (!msg.trim()) return;

    const userMessage = {
        message: msg,
        sender: "user",
        direction: "outgoing",
    };

    const updatedConversation = [...conversation, userMessage];
    setConversation(updatedConversation);
    setMsg("");
    setTyping(true);

    try {
        const messages = updatedConversation.map((msg) => ({
            role: msg.sender === "user" ? "user" : "assistant",
            content: msg.message,
        }));

        const response = await fetch("https://api.openai.com/v1/chat/completions", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${API_KEY}`, 
            },
            body: JSON.stringify({
                model: "gpt-4o", 
                messages: [
                    {
                        role: "system",
                        content: systemContent, 
                    },
                    ...messages,
                ],
                temperature: 0.4, 
            }),
        });

        const data = await response.json();
        console.log("AI raw response:", data); 

        const answer = data?.choices?.[0]?.message?.content?.trim();

        if (answer) {
            const botMessage = {
                message: answer,
                sender: "ivy",
                direction: "incoming",
            };
            setConversation((prev) => [...prev, botMessage]);
        } else {
            throw new Error("No AI response");
        }
    } catch (error) {
        console.error("Error getting response from AI:", error);
        setConversation((prev) => [
            ...prev,
            {
                message: "Oops! Something went wrong. Please try again.",
                sender: "ivy",
                direction: "incoming",
            },
        ]);
    } finally {
        setTyping(false);
    }
};


    useEffect(() => {
        if (!isFullscreen) {
        }
    }, [isFullscreen])

    // function scrollToBottom() {
    //     const chatBody = document.getElementById("chatBody");
    //     // chatBody.scrollTop = chatBody.scrollHeight;
    // }


    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop =
                chatContainerRef.current.scrollHeight;
        }
    }, [conversation]);

    useEffect(() => {
        chatContainerRef.current?.lastElementChild?.scrollIntoView();
    }, [conversation]);
    // console.log("scroll", scrollToBottom);



    return (
        <>
            <div className="main-wrapper-dashboard">
                <div className='left-sidebar'>
                    <div className={`h-screen ${isOpen ? 'full-width' : 'small-width'}`}>
                        <button className={`${isOpen ? 'left-arrow' : 'right-arrow'}`} onClick={toggleSidebar}></button>
                        <div className="user-img">
                            <img src={adminimg} alt='' className={`${isOpen ? 'full-img' : 'small-img'}`} />
                            <span className="online-point" />
                            {isOpen && (<div className="user-info">
                                <div className="jack-name">James Moors</div>
                                <div className="jack-status">Online</div>
                            </div>)}
                        </div>
                        <nav className="nav-bar">
                            <MenuItem icon={<div className="home-icon" />} label="Home" isActive isOpen={isOpen} activeItem={activeItem} setActiveItem={setActiveItem} />
                            <MenuItem icon={<div className='accounting-icon' />} label="Accounting" isOpen={isOpen} activeItem={activeItem} setActiveItem={setActiveItem} />
                            <MenuItem icon={<div className='reports-icon' />} label="Reports" isOpen={isOpen} activeItem={activeItem} setActiveItem={setActiveItem} />
                            <MenuItem icon={<div className='marketplace-icon' />} label="App Marketplace" isOpen={isOpen} activeItem={activeItem} setActiveItem={setActiveItem} />
                            <MenuItem icon={<div className='notification-icon' />} label="Notifications" isOpen={isOpen} activeItem={activeItem} setActiveItem={setActiveItem} />
                            <MenuItem icon={<div className='massages-icon' />} label="Massages" isOpen={isOpen} activeItem={activeItem} setActiveItem={setActiveItem} />
                        </nav>
                        <nav className="nav-bar-bottom">
                            <MenuItem icon={<div className='help-icon' />} label="Help" isOpen={isOpen} activeItem={activeItem} setActiveItem={setActiveItem} />
                            <MenuItem icon={<div className='settings-icon' />} label="Settings" isOpen={isOpen} activeItem={activeItem} setActiveItem={setActiveItem} />
                            <MenuItem icon={<div className='logout-icon' />} label="Logout" isOpen={isOpen} activeItem={activeItem} setActiveItem={setActiveItem} />
                        </nav>
                        <div className="bottom-logo-img" onClick={() => setShowChat(true)}>
                            <img src={leftlogo} alt='' className={`${isOpen ? 'full-img' : 'small-img'}`} />
                            {isOpen && (<div className="logo-info">
                                <div className="ask-name">Ask Ivy</div>
                            </div>)}
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={showChat} onHide={handleCloseChat} className={`${isFullscreen ? "FullScreenView" : "smallScreenView"
                } chat-modal`}>
                <Modal.Header>
                    <Modal.Title>Ask</Modal.Title>
                    <div className='veiw-file'>
                        <button type="button" className="btn btn-primary btn-secondary">
                            <img
                                src={!isFullscreen ? veiwFile : veiwFile}
                                alt=""
                                className={`${isFullscreen ? "FullScreenView" : "smallScreenView"
                                    }`}
                                onClick={() => setIsFullScreen(!isFullscreen)}
                            />
                        </button>
                        <button closeButton onClick={handleCloseChat}>
                            <img src={closeicon} alt="close" className='close-icon' />
                        </button>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <p className='show-content'>Your personal AI legal assistant</p>
                    <div className="massage-content chat-body scrollable-container" id="chatBody">
                        {isChat && (
                            <div className="container" style={{ padding: "0px" }}>
                                <div className="bottom-icon chat-close">
                                </div>
                                <div className="chat-container">
                                    {
                                        <div
                                            className="messages"
                                            ref={chatContainerRef}
                                            onKeyDown={(e) => e.key === "Enter" && handleSend()}
                                            onKeyUp={(e) => e.key === "Enter" && handleSend()}
                                            tabIndex="0"
                                            style={{
                                                overflowY: "auto",
                                            }}
                                        >
                                            {conversation.map((msg, index) => (
                                                <div
                                                    key={index}
                                                    className={`message ${msg.direction === "outgoing" ? "outgoing" : "incoming"
                                                        }`}
                                                >
                                                    <div className="message-content">
                                                        <p>{msg.message}</p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    }
                                </div>
                                {/* <button  className="scroll-btn"> */}
                                    {/* <img src={arrow} alt="" />
                                </button> */}
                            </div>
                        )}
                    </div>
                    {typing && (
                        <div className="typing">
                            <div class="ball"></div>
                            <div class="ball"></div>
                            <div class="ball"></div>
                        </div>
                    )}
                   <div className="user-input">
                    <div className="message-input">
                        <input
                            type="text"
                            placeholder="Message"
                            value={msg}
                            onFocus={() => {
                                setIsChat(true);
                            }}
                            onChange={handleOnChange}
                            onKeyDown={(e) => e.key === "Enter" && handleSend()}
                        />
                        <button
                            disabled={msg == "" ? true : false}
                            className={`${msg == "" ? "disabled" : "send-button"}`}
                            onClick={() => handleSend()}
                            onKeyDown={(e) => e.key === "Enter" && handleSend()}
                        >
                            <img src={arrow} alt="" />
                        </button>
                    </div>
                    <p>Ivy may display inaccurate info. You can always double check with a human.</p>
                </div>
                </Modal.Body>
            </Modal>
        </>

    );
}


function MenuItem({ icon, label, isOpen, activeItem, setActiveItem }) {
    const navigate = useNavigate();


    const handleClick = () => {
        if (label === "Logout") {
            const confirmed = window.confirm("Are you sure you want to logout?");
            if (confirmed) {
                navigate("/");
            }
            return;
        }

        setActiveItem(label);
        navigate('/dashboard');
    };

    return (
        <div className={`list-item transition cursor-pointer ${activeItem === label ? 'active' : ''
            }`}
            onClick={() => {
                setActiveItem(label);
                navigate('/dashboard');
                handleClick()
            }}>
            <div className="text-xl">{icon}</div>
            {isOpen && <span className="item-content">{label}</span>}
        </div>
    );
}

export default Sidebar;